<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-07-10 13:48:42
-->
<template>
    <div>
        <a-page-header
            :style="{ background: 'var(--color-bg-2)' }"
            :show-back="false"
        >
            <template #breadcrumb>
                <a-breadcrumb>
                    <a-breadcrumb-item v-for="(item,index) in breadcrumbList" :key="index" class="breadcrumb">
                        <component :is="$arcoVueIcon[item.icon]" :size="16" style="margin-right:5px;"/> {{ item.title }}
                    </a-breadcrumb-item>
                </a-breadcrumb>
            </template>
        </a-page-header>
    </div>
</template>

<script setup>
    import { onMounted, ref, watch } from 'vue';
    import { useRoute } from 'vue-router';
    import { useI18n } from 'vue-i18n';


    const route = useRoute()
    const { t } = useI18n()
    const breadcrumbList = ref([])


    const getPath = ()=>{
        breadcrumbList.value = []
        route.matched.forEach((item,index)=>{
            if(index > 0){
                breadcrumbList.value.push({
                    title:t(item.meta.locale),
                    icon:item.meta.icon,
                })
            }
        })
    }

    watch(
        ()=>route.path,
        (val)=>{
            getPath()
        }
    )

    onMounted(()=>{
        getPath()
    })
    

</script>

<style lang="less" scoped>
/deep/ .arco-page-header-main{
    min-height: 0;
}

/deep/ .arco-page-header-with-breadcrumb{
    padding: 5px 0 0;
}

/deep/ .arco-breadcrumb-item:last-child{
    font-weight: bold !important;
}
</style>